module.exports = __webpack_public_path__ + "img/profile_box_gray_coach_type.ce188ed9.svg";